import React from 'react';
 export const MyContext = React.createContext(null);
 export const Provider = MyContext.Provider;
 export const Consumer = MyContext.Consumer;
